import { Authorization } from "../providers/AuthContextProvider";
import { CartContext } from "../providers/CartContextProvider";
import { useContext } from "react";
import Cookies from 'js-cookie';
import { useNavigate } from "react-router-dom";


const useLogout = () => {
    const push = useNavigate()
    const { dispatch } = useContext(CartContext)
    const { setUser, setTokens } = useContext(Authorization)

    const logOut = () => {
        dispatch({ type: "CLEAR" })
        push('/')
        setTokens(null)
        setUser({})
        Cookies.remove('token')
        Cookies.remove('user')
    }
    
    return logOut
};

export default useLogout;